import routes from '@/constants/routes';
/* IMAGE STYLING ORDER
  1. Hero Image,
  2. Listing Card One
  3. Listing Card Two
  4. Single Pie Chart
  5. Dual Donut Chart
  6. Single Bar Chart
  7. Tiny Bar Chart
*/
export const SELL_YOUR_HOME_STYLES = [
  {
    width: '836px',
    height: '836px',
    top: '-266px',
    right: '-100px',
    zIndex: 3,
    scale: 0.9,
  },
  {
    width: '150px',
    height: '200px',
    top: '-135px',
    right: '210px',
    zIndex: 2,
  },
  {
    width: '150px',
    height: '200px',
    top: '-185px',
    right: '40px',
    zIndex: 2,
  },
  {
    width: '130px',
    height: '110px',
    bottom: '100px',
    right: '250px',
    zIndex: 5,
  },
  {
    width: '195px',
    height: '135px',
    bottom: '65px',
    right: '165px',
    zIndex: 4,
  },
  {
    width: '91px',
    height: '109px',
    bottom: '110px',
    right: '25px',
    zIndex: 4,
  },
  {
    width: '56px',
    height: '32px',
    bottom: '45px',
    right: '290px',
    zIndex: 4,
  },
];

export const BUY_YOUR_HOME_STYLES = [
  {
    width: '836px',
    height: '836px',
    top: '-290px',
    right: '-100px',
    scale: 0.85,
    zIndex: 1,
  },
  {
    width: '150px',
    height: '200px',
    top: '-175px',
    right: '40px',
    zIndex: 1,
  },
  {
    width: '150px',
    height: '200px',
    top: '290px',
    right: '280px',
    zIndex: 1,
  },
  {
    width: '130px',
    height: '110px',
    top: '-75px',
    right: '425px',
    zIndex: 2,
  },
  {
    width: '195px',
    height: '135px',
    bottom: '150px',
    right: '-10px',
    zIndex: 2,
  },
  {
    width: '91px',
    height: '109px',
    bottom: '200px',
    right: '140px',
    zIndex: 3,
  },
  {
    width: '56px',
    height: '32px',
    bottom: '165px',
    right: '160px',
    zIndex: 3,
  },
];

export const BUY_SELL_YOUR_HOME_STYLES = [
  {
    width: '836px',
    height: '836px',
    bottom: '-62px',
    right: '-180px',
    scale: 0.85,
    zIndex: 2,
  },
  {
    width: '150px',
    height: '200px',
    top: '-140px',
    right: '250px',
    zIndex: 1,
  },
  {
    width: '150px',
    height: '200px',
    top: '-70px',
    right: '-40px',
    zIndex: 3,
  },
  {
    width: '130px',
    height: '110px',
    top: '90px',
    right: '435px',
    zIndex: 4,
  },
  {
    width: '195px',
    height: '135px',
    bottom: '195px',
    right: '300px',
    zIndex: 3,
  },
  {
    width: '91px',
    height: '109px',
    bottom: '290px',
    right: '180px',
    zIndex: 4,
  },
  {
    width: '56px',
    height: '32px',
    bottom: '200px',
    right: '460px',
    zIndex: 4,
  },
];

export const STYLES_BY_ROUTE = {
  [routes.sellYourHome]: SELL_YOUR_HOME_STYLES,
  [routes.buyYourHome]: BUY_YOUR_HOME_STYLES,
  [routes.buySellYourHome]: BUY_SELL_YOUR_HOME_STYLES,
};

export default {
  SELL_YOUR_HOME_STYLES,
  BUY_YOUR_HOME_STYLES,
  BUY_SELL_YOUR_HOME_STYLES,
  STYLES_BY_ROUTE,
};
